export default __webpack_public_path__ + "static/integrations_meta-7b2529a1343963c080a2bd96961d7963.png";